import React from "react";
import OptimizedImage from "./OptimizedImage";

const Footer = () => (
    <footer id="footer" className="bg-gray-100 py-12 border-t">
        <div className="container mx-auto px-4 grid md:grid-cols-4 gap-8">
            {/* About */}
            <div>
                <h2 className="text-2xl font-bold text-green-600 mb-4">Africa Research University</h2>
                <p className="text-gray-700 text-sm mb-4">
                    Quadrant Office Park<br />Great East Road <br />Lusaka, Zambia
                </p>
                <p className="text-sm text-gray-700">
                    <strong>Phone:</strong> +260 773 029344<br />
                    <strong>Email:</strong> admissions@africaresearchuniversity.com
                </p>
                <div className="flex space-x-3 mt-4 text-green-600">
                    <a href="https://www.facebook.com/africaresearchuniversityS"><i className="bi bi-facebook"></i></a>
                    <a href="https://whatsapp.com/channel/0029Vb5zVksDp2QGvNQX1530"><i className="bi bi-whatsapp"></i></a>
                    <a href="https://www.linkedin.com/school/africa-research-university-aru"><i className="bi bi-linkedin"></i></a>
                    <a href="https://x.com/africaresearchu"><i className="bi bi-twitter"></i></a>
                    <a href="https://www.tiktok.com/@africaresearchuniversity"><i className="bi bi-tiktok"></i></a>
                </div>
            </div>

            {/* Useful Links */}
            <div>
                <h4 className="font-semibold text-gray-800 mb-4">Useful Links</h4>
                <ul className="space-y-2 text-sm">
                    {[
                        { label: "Home", href: "/" },
                        { label: "Online Classes", href: "/online-classes" },
                        { label: "Programmes", href: "/courses" },
                        { label: "Vacancies", href: "/jobs" },
                        { label: "Contact Us", href: "/contact" },
                        { label: "Ethics Committee", href: "/ethics-committee" },
                    ].map((link, i) => (
                        <li key={i}><a href={link.href} className="hover:text-green-600">{link.label}</a></li>
                    ))}
                </ul>
            </div>

            {/* Services */}
            <div>
                <h4 className="font-semibold text-gray-800 mb-4">Academic Schools</h4>
                <ul className="space-y-2 text-sm">
                    {[  "Institute for Research and Development",
                        "School of Business and Development Studies",
                        "School of Postgraduate Studies",
                    ].map((service, i) => (
                        <li key={i}><a href="/courses" className="hover:text-green-600">{service}</a></li>
                    ))}
                </ul>
            </div>

            {/* Logo */}
            <div className="flex items-center justify-center">
                <a href="/" className="block text-center">
                    <OptimizedImage src="/assets/img/arulogo.png" alt="Africa Research University - return to home page" className="w-46 mx-auto" width={200} height={80} />
                </a>
            </div>
        </div>

        <div className="text-center mt-10 text-sm text-gray-600">
            <p>
                © <strong>Africa Research University 2025</strong>. All Rights Reserved
            </p>
        </div>
    </footer>
);

export default Footer;
